import { render, staticRenderFns } from "./TaxPayer.vue?vue&type=template&id=7c50041c"
import script from "./TaxPayer.vue?vue&type=script&lang=ts"
export * from "./TaxPayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports